import { createSelector } from '@reduxjs/toolkit';

import { naturalSortByProperty } from '@paragon/utilities';

import { RootState } from '../store';

export const getTrailerOptions = createSelector(
  (state: RootState) => state.trailers,

  (trailers) =>
    naturalSortByProperty(
      Object.values(trailers).filter((trailer) => !trailer.archived),
      (trailer) => trailer.name,
    ),
);
